import React, { useEffect, useState } from 'react';
import img from '../assets/images/team/team-details.jpg'
import axios from 'axios';



function Test(props) {

    const [offers,setOffers]=useState([]);

    const getOffers=()=>{
        axios.get('https://api.masterfut.com/api/offres')
        .then(res=>setOffers(res.data.offres));
    
    }

    useEffect(() => {
        getOffers();
    }, [])
    
    return (
        <div className='team-page'>

            

            <section className="tf-section tf-team-detail">
                <div className="tf-container">
                    <div className="row ">   
                        <div className="col-md-6">
                            <div className="swiper-container team-details ">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <div className="slider-item">
                                            <img src={img} alt="Binabox" />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="content-detail">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Offer Title</th>
                                            <th>Description</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {offers.map((offer, index) => (
                                            <tr key={index}>
                                                <td>{offer.titre}</td>
                                                <td>{offer.etat}</td>
                                                <td>{offer.montant}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            
            
        </div>
    );
}

export default Test;